import { createMfaApi } from '@f2m3/shared-api';
import apiClient from './apiClient';

// Shared management-endpoint calls bound to this app's configured apiClient.
// Login-completion calls (mfa verify, passwordless login) live in userApi /
// the ceremony helpers because they carry the guest-cart token.
const mfaApi = createMfaApi(apiClient);

export default mfaApi;

export type { MfaStatus, PasskeyInfo, TotpSetupResult } from '@f2m3/shared-api';
